const en = {
	pages: {
		login: {
			title: "Log in to the app",
			username: "Username",
			password: "Password",
			signIn: "Log in",
			validation: {
				usernameRequired: "Enter username to login!",
				passwordRequired: "Enter password!"
			},
			errors: {
				failedAttempt: "Username or password was incorrect!"
			}
		},
		logout: "Logout",
		home: {
			title: "Home"
		},
		reports: {
			downloadLink: "Download report",
			filter: "Filtering"
		},
		pageHeader: {
			title: "Statistics"
		},
		pageFooter: {
			contentRangeOfYears: "©{{createdYear}}-{{currentYear}} Centar za digitalizaciju d.o.o.",
			contentSingleYear: "©{{createdYear}} Centar za digitalizaciju d.o.o."
		},
		languagePicker: "Change language",
		userProfile: {
			title: "User profile",
			changePassword: {
				title: "Change password",
				oldPassword: "Old password",
				newPassword: "New password",
				confirmNewPassword: "Confirm new password"
			}
		},
		favorites: {
			title: "Favorites"
		}
	},
	sections: {
		croatianOlympicCommittee: {
			title: "Categorization",
			codebook: "Registry",
			sportsAssociations: "Sport associations",
			sportsAssociationData: "Association",
			sports: "Sports",
			sportsBranches: "Sports branches",
			ages: "Ages",
			competitionTypes: "Competition types",
			organizationTypes: "Organization types",
			categoryRequestStatuses: "Request statuses",
			categoryRequestTypes: "Request types",
			competitionKindEnum: {
				0: "Unknown",
				1: "I (individual competition)",
				2: "E (team competition)",
				3: "P (competition of pairs and crews)",
				4: "T (team competition with individual results)"
			},
			sportTypeEnum: {
				0: "O - Olympic",
				1: "N - Nonolympic"
			},
			organizations: {
				title: "Organizations",
				companyData: "Legal entity",
				organizationData: "Organization",
				nameHistoryData: "Name changes",
				companyTitle: "Entity name",
				companyPersonalId: "Entity PIN",
				companyContactData: "Contact data",
				companyAddresses: "Addresses",
				companyEmails: "Emails",
				companyPhoneNumbers: "Phone numbers",
				addCompany: "Add legal entity",
				editCompany: "Edit legal entity"
			},
			organizationNames: {
				title: "OrganizationNameChanges"
			},
			athletes: {
				title: "Athletes",
				personData: "Physical entity",
				athleteData: "Athlete",
				personFirstName: "First name",
				personLastName: "Last name",
				personPersonalId: "Entity PIN",
				personDateOfBirth: "Date of birth",
				personContactData: "Contact data",
				personAddresses: "Addresses",
				personEmails: "Emails",
				personPhoneNumbers: "Phone numbers",
				addPerson: "Add physical entity",
				editPerson: "Edit physical entity",
				reports: {
					allCategories: "Report - all categories",
					activeCategories: "Report - active categories"
				}
			},
			categoryTypes: "Category marks",
			categories: {
				title: "Categories",
				categoryData: "Category",
				competitionData: "Competition",
				pleadingData: "Pleadings",
				requestData: "Requests",
				createCategory: "Create category with resolution",
				reports: {
					summaryReport: {
						title: "Report on categories achieved by sports",
						shortTitle: "Report by sports",
						dateFrom: "Date from",
						dateTill: "Date till",
						sportIds: "Sports",
						selectedSports: "selected sports"
					},
					generalReport: {
						title: "Categories - general report",
						shortTitle: "General report",
						fileName: "Categories - report",
						reportOutputType: "Report format",
						active: "Only active",
						isAnnulled: "Annulled",
						dateFrom: "Valid from",
						dateTill: "Valid till",
						resolutionDateFrom: "Resolution date from",
						resolutionDateTill: "Resolution date till",
						athleteIds: "Athletes",
						organizationIds: "Organizations",
						categoryTypeIds: "Category types",
						sportIds: "Sports",
						athleteCityIds: "Cities (athlete)",
						athleteCountyIds: "Counties (athlete)",
						athleteCountryIds: "Countries (athlete)",
						organizationCityIds: "Cities (organization)",
						organizationCountyIds: "Counties (organization)",
						ageIds: "Ages",
						competitionTypeIds: "Competition types",
						competitionKinds: "Competition kinds",
						sportTypes: "Sport types",
						competitionDateFrom: "Competition date from",
						competitionDateTill: "Competition date till",
						selectedSports: "selected sports",
						selectAthletes: "Select athletes",
						selectOrganizations: "Select organizations",
						selectCategoryTypes: "Select cat. types",
						selectCities: "Select cities",
						selectCounties: "Select counties",
						selectCountries: "Select countries",
						selectAges: "Select ages",
						selectCompetitionTypes: "Select competition types",
						selectCompetitionKinds: "Select competition kinds",
						selectSportTypes: "Select sport types",
						reportOutputTypeEnum: {
							0: "XLSX",
							1: "CSV"
						}
					},
					cocWebReport: {
						titleXlsx: "Web report - XLSX",
						titleCsv: "Web report - CSV",
						fileName: "Categories - web report"
					},
					azvoReport: {
						titleXlsx: "AZVO report - XLSX",
						titleCsv: "AZVO report - CSV",
						fileName: "Categories - AZVO report"
					}
				}
			},
			categoryRequests: {
				title: "Requests",
				requestData: "Request",
				athleteData: "Athlete",
				pleadingData: "Pleadings",
				createRequest: "Create request",
				createResolution: "Create resolution"
			},
			categoryRequestForms: {
				title: "Forms",
				new: "Categorization",
				clubChange: "Club change",
				extension: "Extension",
				all: "All",
				athleteData: "Athlete personal data",
				organizationData: "Sports affiliation data",
				competitionData: "Achieved result",
				extensionData: "Categorization resolution",
				useCategoryRequestFormForm: {
					title: "Create request",
					requestFormNumber: "Form number",
					requestFormPersonName: "Name",
					requestFormPersonPersonalId: "Personal id",
					requestFormPersonBirthDate: "Birth date",
					athleteId: "Athlete selection",
					athleteCode: "Code",
					athleteName: "Name",
					athletePersonalId: "Personal id",
					athleteBirthDate: "Birth date",
					athleteDetails: "View athlete data",
					newAthlete: "Create new",
					files: "Files",
					info: "Creating request from form, case and submission (with updating athlete data)",
					navigateToCategoryRequest: "Go to request"
				}
			},
			validations: {
				sportsAssociationHigherLevelChildExists: "The parent alliance must be of a higher level than the subordinates!",
				categoryAnnullmentDateRequired: "Field is required!"
			}
		},
		incomingShipments: {
			title: "Incoming shipments",
			type: "Incoming shipment",
			regularIncomingShipments: {
				title: "Regular",
				unclassified: "Unclassified",
				restricted: "Restricted",
				confidential: "Confidential",
				secret: "Secret",
				topSecret: "Top secret"
			},
			unopenedIncomingShipments: {
				title: "Unopened",
				businessPartner: "Business partner",
				employee: "Employee",
				classificationLevel: "Classification lebel",
				inappropriateContent: "Inappropriate content",
				damagedOrOpenedShipment: "Damaged/opened shipment",
				valuableShipment: "Valuable shipment",
				hazardousShipment: "Hazardous shipment",
				wrongDelivery: "Wrong delivery",
				forHeadOfPublicCompany: "For Head of public company",
				forwardingToKeyEnum: {
					employee: "Zaposlenik",
					partner: "Poslovni partner"
				}
			},
			addSenderForm: {
				addPartner: "Add a partner",
				addUnsortedContact: "Add an unsorted contact",
				publicCompaniesLabel: "Public companies",
				companiesLabel: "Companies",
				peopleLabel: "People"
			},
			recipientKeyEnum: {
				orgUnit: "Org. unit",
				employee: "Employee",
				partner: "Business partner"
			},
			senderKeyEnum: {
				partner: "Business partner",
				employee: "Employee",
				unsorted: "Unsorted contact"
			},
			deliveryTypeEnum: {
				0: "Personal",
				1: "Mail",
				2: "Registered mail",
				3: "Mail with return receipt",
				4: "Delivery service",
				5: "Email",
				6: "eDelivery"
			}
		},
		outgoingShipments: {
			title: "Outgoing shipments",
			outgoingShipments: {
				title: "Shipments",
				editEmailRowButtonText: "Edit email"
			},
			ePK: {
				title: "e-PK",
				generateEpkFileDialogButton: "Generate e-PK",
				stepper: {
					initialData: {
						title: "Initial data",
						selectCodePlaceholder: "Find destination postal office"
					},

					parcelData: {
						title: "Parcels data",
						selectParcelIndication: "Select a parcel!",
						parcelDeliveryTypeNotSupport: "Delivery type not supported!"
					},
					result: {
						title: "Generated e-PK",
						successMessage: "e-PK successfully generated!",
						errorMessage: "An error occurred, e-PK was not generated!"
					}
				},
				configuration: {
					title: "Configuration"
				},
				files: {
					title: "Epk files",
					updateShipmentStatusButtonText: `Change shipment statuses`,
					updateShipmentStatusConfirmationText: `Shipment statuses will be changed to "Sent". Do you wish to continue?`,
					updateShipmentStatusToRejectedConfirmationText: "Status pošiljki će ostati nepromijenjen. Želite li nastaviti?",
					uploadRefNumberRowButtonText: "Upload reference number",
					uploadedRefSuccess: "Reference number successfully set!",
					statusesChangedSucces: "Statuses changed successfully!"
				}
			},
			createEmailForm: {
				title: "Quick create e-mails",
				info: "E-mail is created only for shipment which has E-mail delivery type, has set e-mail template and for which previously e-mail wasn't created",
				status: {
					skipped: "E-mail is not created",
					created: "E-mail is created and status updated"
				}
			},
			outgoingShipmentUpdateForm: {
				title: "Update send status",
				sendDate: "Send date",
				outgoingShipmentStatusId: "Status",
				selectShipmentStatus: "Select status"
			},
			confirmShipmentReceiptForm: {
				title: "Confirm shipment receipt",
				receiptDate: "Receipt date",
				buttonText: "Confirm receipt"
			},
			admissionBookReportForm: {
				titleShort: "Admission book",
				title: "Admission book report",
				sendDate: "Send date",
				usedDeliveryTypes: "Delivery types",
				postalOffice: "Postal office"
			},
			pleadingDispatches: {
				title: "Dispatches",
				defaultAddText: "Dispatch pleading",
				dispatchCaseText: "Dispatch case",
				dispatchCaseControl: {
					selectCaseLabel: "Case",
					selectCasePlaceholder: "Select case",
					pleadingTypesLabel: "Pleading types",
					pleadingTypesPlaceholder: "Select pleading types",
					deliveryTypesLabel: "Delivery types",
					deliveryTypesPlaceholder: "Select delivery types",
					sendDateLabel: "Send date",
					recipientsTypeLabel: "Recipients type",
					recipientsTypePlaceholder: "Select recipients type",
					partnersLabel: "Additional partners",
					partnersPlaceholder: "Select partners",
					dispatchButtonText: "Dispatch",
					atLeastOnePartnerRequired: "At least one recipient is required!"
				},
				createOutgoingShipmentWizard: {
					title: "Create outgoing shipment",
					selectPleadingDispatchesStep: {
						title: "Dispatches selection",
						pleadingDispatchTableTitle: "Selected dispatches overview",
						pleadingAttachmentTableTitle: "Attachments overview"
					},
					setOutgoingShipmentDataStep: {
						title: "Shipment data entry"
					},
					createOutgoingShipmentStep: {
						title: "Create shipment confirmation"
					},
					createOutgoingShipmentDeliveryTemplateEditStep: {
						title: "Edit delivery template",
						shipmentCreatedTitle: "Shipment successfully created!",
						goToShipmentButtonText: "Go to created shipment",
						editSaveTemplateButtonText: "Edit and save email",
						email: {
							title: "Edit shipment email template"
						}
					}
				},
				createPleadingDispatchesForm: {
					title: "Quick create dispatches",
					pleadingId: "Pleading",
					selectPleadings: "Select pleading",
					deliveryTypes: "Delivery type",
					selectDeliveryTypes: "Select delivery types",
					emailTemplateId: "Email template",
					selectEmailTemplate: "Select email template",
					sendDate: "Send date",
					partnerIds: "Recipients",
					selectPartners: "Select recipient",
					selectPartnerTypes: "Select recipient types",
					selectAll: "All recipients",
					selectMainOnly: "Main recipient",
					selectOthersOnly: "Other recipient",
					selectAdditionalPartners: "Additional partners",
					selectParty: "Party",
					selectLegalRepresentative: "Legal representative",
					createdSuccessMessage: "Successfully created {{count}} dispatches!",
					createdWarningMessage: "No dispatch was created!",
					info: "Dispatch will be created if .pdf attachment exists and also contact for delivery type"
				},
				createOutgoingShipmentForm: {
					title: "Quick create shipments",
					pleadingDispatchIds: "Dispatches",
					selectPleadingDispatches: "Select dispatches",
					documentTypesForDeliveryType: "Document type fro delivery type",
					selectDocumentType: "Select document type",
					sendDate: "Send date",
					outgoingShipmentStatusId: "Status",
					selectShipmentStatus: "Select status",
					groupByRecipient: "Group by recipient address"
				}
			},
			emailTemplates: {
				title: "E-mail templates"
			}
		},
		invoices: {
			title: "Invoices",
			invoiceAttachments: {
				title: "Attachments"
			}
		},
		publicAdministration: {
			title: "Public administration",
			invalidate: "Invalidate",
			assign: "Assign",
			assignmentSuccessfulMessage: "{{value}} successfully assigned!",
			administrativeProceedingInfo: "Administrative proceeding info",
			cases: {
				title: "Cases",
				type: "Case",
				openingDate: "Case opening date",
				closingDate: "Case closing date",
				fileReferenceNumber: "File reference number",
				invalidate: "Invalidate",
				confirmInvalidate: "Case will be invalidated, do you want to continue?",
				invalidateCaseSuccess: "Case {{case}} successfully invalidated!",
				invalidateCaseError: "An error occurred, case {{case}} was not invalidated!",
				setInProgressButtonText: "Set In Progress",
				confirmSetInProgress: "Case status will be set to In Progress, do you want to continue?",
				confirmSetInProgressSuccess: "In Progress status successfully set",
				confirmSetInProgressError: "Error occurred during transition to In Progress status",
				setIssuedForInspectionButtonText: "Set Issued For Inspection",
				confirmSetIssuedForInspection: "Case status will be set to Issued For Inspection, do you want to continue?",
				confirmSetIssuedForInspectionSuccess: "Issued For Inspection status successfully set",
				confirmSetIssuedForInspectionError: "Error occurred during transition to Issued For Inspection status",
				setReturnedToArchiveButtonText: "Return to archive",
				confirmSetReturnedToArchive: "Case status will be set to Archived, do you want to continue?",
				confirmSetReturnedToArchiveSuccess: "Case returned to archive successfully",
				confirmSetReturnedToArchiveError: "Error occurred during returning case to archive",
				returnFromArchiveButtonText: "Return from archive",
				confirmReturnFromArchive: "Case will be returned from archive, do you want to continue?",
				confirmSetReturnedFromArchiveSuccess: "Case returned from archive successfully",
				confirmSetReturnedFromArchiveError: "Error occurred during returning case from archive",
				extractFromSystemButtonText: "Extract from system",
				confirmExtractFromSystem: "Case will be extracted from the system, do you want to continue?",
				confirmExtractFromSystemSuccess: "Case successfully extracted from the system",
				confirmExtractFromSystemError: "An error occurred, case was not extracted from the system!",
				heldIndefinitely: "Held indefinitely",
				caseNotes: "Case notes",
				caseAudit: "Case audit",
				auditExportFileName: "case-audit-export",
				archiveData: {
					title: "Archival log entries"
				},
				caseStatusEnum: {
					open: "Open",
					cancelled: "Cancelled",
					closed: "Closed",
					inProgress: "In progress",
					archived: "Archived",
					issuedForInspection: "Issued for inspection"
				},
				gridExportBaseFileName: "CasesGridExport",
				caseResolutionFilterEnum: {
					1: "All",
					2: "Solved",
					3: "Unsolved"
				}
			},
			acts: {
				title: "Acts",
				type: "Act",
				confirmInvalidate: "Act will be invalidated, do you want to continue?",
				invalidateActSuccess: "Act {{value}} successfully invalidated!",
				invalidateActError: "An error occurred, act {{value}} was not invalidated!",
				pleadingDispatches: "Pleading dispatches",
				actAudit: "Act audit",
				auditExportFileName: "act-audit-export",
				validations: {
					sendToPartnerIncludedInOtherPartners: "Recipient must not be included in other recipients!"
				},
				gridExportBaseFileName: "ActsGridExport"
			},
			internalActs: {
				title: "Internal acts",
				type: "Internal act",
				confirmInvalidate: "Internal act will be invalidated, do you want to continue?",
				invalidateInternalActSuccess: "Internal act {{value}} successfully invalidated!",
				invalidateInternalActError: "An error occurred, internal act {{value}} was not invalidated!",
				internalActAudit: "Internal act audit",
				auditExportFileName: "internal-act-audit-export",
				gridExportBaseFileName: "InternalActsGridExport"
			},
			submissions: {
				title: "Submissions",
				type: "Submission",
				confirmInvalidate: "Submission will be invalidated, do you want to continue?",
				invalidateSubmissionSuccess: "Submission {{ value }} successfully invalidated!",
				invalidateSubmissionError: "An error occurred, submission {{ value }} was not invalidated!",
				submissionAudit: "Submission audit",
				auditExportFileName: "submission-audit-export",
				gridExportBaseFileName: "SubmissionsGridExport"
			},
			pleadingAttachments: {
				title: "Pleading attachments",
				fileContentName: "File content",
				previewDocxButton: "Preview document",
				overwriteCurrentFileButton: "Overwrite with new content",
				overwriteSuccess: "File successfully overwritten",
				overwriteFailure: "An error occurred while overwriting the file",
				attachmentLockedEditButtonTooltip: "To edit the attachment, it needs to be unlocked first.",
				editDocxButton: "Edit document",
				confirmLock: "Are you sure you want to lock the attachment?",
				confirmUnlock: "Are you sure you want to unlock the attachment?",
				lockAttachmentFailure: "An error occurred while locking the attachment",
				lockAttachmentSuccess: "Attachment locked successfully",
				unlockAttachmentFailure: "An error occurred while unlocking the attachment",
				unlockAttachmentSuccess: "Attachment unlocked successfully",
				archiveName: "{{name}} - Attachments",
				stickBarcode: "Append barcode",
				stickBarcodeSuccess: "Barcode successfully appended!",
				stickBarcodeError: "An error occured, barocode wasn't appended!",
				convertToPdf: "Convert to PDF",
				convertToPdfWithBarcode: "Convert to PDF with barcode",
				convertToPdfSuccess: "File successfully converted to PDF!",
				convertToPdfError: "An error occured, file wasn't convertedb to PDF",
				selectScanner: "Select Scanner",
				scan: "Scan",
				scanSuccess: "Document scanned successfully",
				scanError: "Failed to scan document",
				selectScannerWarning: "Please select a scanner",
				discoverScannersError: "Failed to discover scanners",
				discoveringScannersMessage: "Discovering scanners...",
				noScannersFoundMessage: "No scanners found. Please make sure your scanners are connected and powered on.",
				availableScannersLabel: "Available Scanners ({{count}}):",
				validateSignatures: "Validate Signatures",
				validateSignaturesSuccess: "Signatures successfully validated!",
				validateSignaturesError: "An error occurred while validating signatures"
			},
			pleadingNotes: {
				title: "Pleading notes"
			},
			pleadingStatuses: {
				0: "Custom",
				1: "Opened",
				2: "Cancelled",
				3: "Closed",
				4: "In progress",
				5: "Approval requested",
				6: "Approval rejected",
				7: "Approval granted",
				8: "Ready for dispatch",
				9: "Dispatched",
				10: "Returned from dispatch"
			},
			dossiers: {
				title: "Dossiers"
			},
			pleadingApprovals: {
				title: "Approvals",
				changeStatusToInProgressButtonText: "Asssign status to 'In progress'",
				confirmStatusChange: "Pleading status will be changed to '{{pleadingStatus}}', do you want to continue?",
				confirmStatusChangeSuccessful: "Pleading status successfully changed to '{{pleadingStatus}}'!",
				confirmStatusChangeInProgress: "Status of the pleading will be changed to 'In progress'?, do you wish to continue?",
				confirmStatusChangeInProgressSuccessful: "Pleading status successfully changed!",
				approveButtonText: "Approve",
				approvalApprovedMessage: "Pleading approved!",
				rejectButtonText: "Reject",
				requestApprovalButtonText: "Request approval",
				approvalRejectedMessage: "Pleading rejected!",
				approvalRequestedMessage: "Approval requested",
				requestSignatureButtonText: "Request signature",
				signatureRequestedMessage: "Signature requested",
				approvalReason: "Reason",
				sentApprovalsTitle: "Sent approval requests",
				emptySentApprovalsLabel: "No sent approval requests",
				receivedApprovalsTitle: "Received approval requests",
				emptyReceivedApprovalsLabel: "No received approval requests",
				noPleadingAttachments: "No pleading attachments"
			}
		},
		businessPartners: {
			title: "Business partners",
			addresses: "Addresses",
			address: "Address",
			email: "Email",
			phoneNumber: "Phone number",
			telNumbers: "Phone numbers",
			addTelNumber: "Add phone number",
			addAddress: "Add address",
			addEmail: "Add email",
			citySelect: "Select a city",
			main: "Main",
			publicCompanies: {
				title: "Public legal entities",
				syncPublicCompaniesQuestion: "Are you sure you want to sync all public legal entities?",
				synchronize: "Synchronize",
				syncSuccessful: "Synchronization successful",
				syncError: "An error occurred, public companies not synchronized!"
			},
			companies: {
				title: "Legal entities"
			},
			partnerBranchOffices: {
				title: "Partner branch offices"
			},
			persons: {
				title: "Physical entities"
			},
			unsortedContacts: {
				title: "Unsorted contacts"
			},
			contacts: {
				phoneNumbers: {
					type: {
						0: "Home",
						1: "Mobile"
					}
				}
			}
		},
		documentTypes: {
			title: "Registry office documents",
			documentTypes: {
				title: "Document types"
			},
			documentTypeProperties: {
				name: "Name",
				isRequired: "Required"
			},
			documentTypeData: {
				title: "Document data",
				selectDocumentType: "Select document type"
			},
			documentTypeTemplates: {
				title: "Document templates",
				selectDocumentType: "Select document type",
				fileNew: "New",
				fileExisting: "Existing",
				createFromTemplate: "Create from template",
				createFromTemplateMessage: "Document successfully created from template!",
				createFromTemplateErrorMessage: "An error occurred while creating file!",
				createDocument: "Create document",
				newDocumentName: "New document name",
				template: "Template",
				printFromTeplate: "Print from template",
				createFileFromTemplateForm: {
					title: "Template selection",
					newDocumentName: "New file name",
					templates: "Templates for document types",
					selectTemplate: "Select template",
					requiredTemplate: "At least one template must be seleected!"
				}
			},
			documentTypeTemplateProperties: {
				name: "Name",
				templatePlaceholder: "Tag",
				validations: {
					templatePlaceholderRequired: "All tags are required!",
					templatePlaceholderUnique: "All tags must be unique!"
				}
			},
			documentCollections: {
				title: "Folders",
				collections: {
					deleteSingleCollectionSuccess: "Successfully deleted map {{mapName}}",
					deleteSingleCollectionError: "Error while trying to delete map {{mapName}}, please try again",
					deleteMultipleCollectionsSuccess: "Successfully deleted maps!",
					deleteMultipleCollectionsError: "Error while trying to delete maps, please try again",
					deleteMultipleCollectionsConfirmation: `Are you sure you want to delete maps?`,
					createNewMapdrawerTitle: "New map",
					createNewMapButtonText: "Create new map",
					createNewMapSuccess: "Map successfully created!"
				},
				documents: {
					createNewDocumentDrawerTitle: "New document",
					createNewDocumentButtonText: "Create new document",
					createNewDocumentSuccess: "Document successfully created!",
					dragNDropMainText: "Drag and drop a PDF or DOCX file here and create a documennt",
					dragNDropWrongFileTypeText: "Only PDF or DOCX allowed!"
				},
				actionsMenu: {
					open_folder: "Open folder",
					add_folder: "Add folder",
					edit_folder_name: "Edit folder name",
					delete_folder: "Delete folder",
					download_document: "Download document",
					add_document: "Add document",
					preview_document: "Preview document",
					edit_document: "Edit document",
					delete_document: "Delete document"
				}
			},
			approvals: {
				title: "Documents",
				changeStatusToInProgressButtonText: "Asssign status to 'In progress'",
				confirmStatusChange: "Pleading status will be changed to '{{pleadingStatus}}', do you want to continue?",
				confirmStatusChangeSuccessful: "Pleading status successfully changed to '{{pleadingStatus}}'!",
				confirmStatusChangeInProgress: "Status of the pleading will be changed to 'In progress'?, do you wish to continue?",
				confirmStatusChangeInProgressSuccessful: "Pleading status successfully changed!",
				approveButtonText: "Approve",
				confirmReviewButtonText: "Confirm review",
				approvalApprovedMessage: "Pleading approved!",
				rejectButtonText: "Reject",
				requestApprovalButtonText: "Request approval",
				approvalRejectedMessage: "Pleading rejected!",
				approvalRequestedMessage: "Approval requested",
				approvalReason: "Reason",
				sentApprovalsTitle: "Sent approval requests",
				emptySentApprovalsLabel: "No sent approval requests",
				receivedApprovalsTitle: "Received approval requests",
				emptyReceivedApprovalsLabel: "No received approval requests"
			}
		},
		messages: {
			title: "Messages",
			emails: {
				title: "Emails",
				sendAgain: "Send again",
				emailResent: "Email was resent",
				useAttachmentDownloadLinkInfo: "Files are not added as attachments but are downloaded via a generated link",
				missingDownloadLink: "Download link missing!",
				downloadAttachmentFinishedTitle: "Download complete",
				downloadAttachmentFinishedSubtitle: "Successfully downloaded, link can no longer be used",
				downloadAttachmentFileName: "Attachments_{{value}}"
			}
		},
		administration: {
			title: "Administration",
			users: {
				title: "Users",
				confirmActivation: "Are you sure yu want to activate user?",
				confirmDeactivation: "Are you sure yu want to deactivate user?",
				deactivateUserError: "There was an error during user deactivation",
				deactivateUserSuccess: "User deactivated successfuly",
				activateUserError: "There was an error during user activation",
				activateUserSuccess: "User activated successfuly"
			},
			passwordManagement: {
				title: "Password Change",
				changePassword: "Change password",
				changePasswords: "Change passwords",
				newPassword: "New password",
				confirmNewPassword: "Confirm new password",
				confirmNewPasswords: "Confirm new passwords",
				confirmPasswordChange: "Are you sure you want to change the password?",
				confirmPasswordsChange: "Are you sure you want to change the passwords?",
				passwordChangeError: "An error occurred while changing the password",
				passwordsChangeError: "An error occurred while changing the passwords",
				passwordChangeSuccess: "Password successfully changed",
				passwordsChangeSuccess: "Passwords successfully changed",
				passwordTooShort: "Password is too short",
				passwordsDoNotMatch: "Passwords do not match",
				userCount: "Number of selected users: {{count}}",
				errorMessage: "An error occurred, no changes applied!"
			},
			roles: {
				title: "Roles",
				noPermissions: "No permissions",
				editingRoleAccesControl: "Editing access control for role ",
				addWholeGroup: "Add whole group",
				addAllFromGroup: "Add all from group",
				definingAccessControl: "Defining access control",
				addNewPermissions: "Automatically add new permissions",
				addNewSubgroups: "Automatically add new subgroups",
				addNewGroups: "Automatically add new groups"
			},
			registryOffices: {
				title: "Registry offices"
			},
			classification: {
				title: "Classification",
				classificationPlans: "Classification plans",
				classificationMarks: "Classification marks",
				administrativeRegionMainGroups: "Main groups",
				administrativeRegionGroups: "Groups",
				administrativeRegionSubGroups: "Subgroups",
				classificationForms: "Classification forms",
				tradeClassifications: "Trade classifications",
				senderClassificationMarkConfiguration: "Default classification marks for senders"
			},
			systematization: {
				title: "Systematization",
				branchOffices: "Branch offices",
				workplaceSystematization: "Workplace systematization",
				organizationalUnits: "Organizational units",
				workplaces: "Workplaces",
				workplaceEmployees: {
					title: "Workplace employees",
					confirmActivation: "Are you sure you want to activate employee?",
					activateEmployeeSuccess: "Employee activated successfuly",
					activateEmployeeError: "There was an error during employee activation",
					confirmDeactivation: "Are you sure yu want to deactivate employee?",
					deactivateEmployeeSuccess: "Employee deactivated successfuly",
					deactivateEmployeeError: "There was an error during employee deactivation",
					confirmMarkAsZupUser: "Are you sure you want to mark user as ZUP IT user?",
					markAsZupUser: "Mark as ZUP IT user",
					markAsZupUserSuccess: "User marked as ZUP IT user successfuly",
					markAsZupUserError: "There was an error while marking user as ZUP IT user",
					confirmUnmarkAsZupUser: "Are you sure you want to unmark user as ZUP IT user?",
					unmarkAsZupUser: "Unmark as ZUP IT user",
					unmarkAsZupUserSuccess: "User unmarked as ZUP IT user successfuly",
					unmarkAsZupUserError: "There was an error while unmarking user as ZUP IT user"
				},
				employeeGroups: {
					title: "Employee groups"
				}
			},
			codebook: {
				title: "Codebook",
				countries: "Countries",
				counties: "Counties",
				cities: "Cities",
				caseStatuses: "Case statuses",
				pleadingStatuses: "Pleading statuses",
				organizationalUnitTypes: "Organizational unit types",
				documentTypes: "Document types",
				outgoingShipmentStatuses: "Outgoing shipment statuses",
				incomingShipmentStatuses: "Incoming shipment statuses",
				documentCategories: "Document categories",
				pleadingCreatorMarks: "Pleading creator marks",
				postalOffices: "Postal offices"
			},
			customProperties: {
				title: "Custom properties",
				selectCustomPropertyEntity: "Select custom property entity",
				selectCustomPropertyType: "Select custom property type",
				selectRelationType: "Select relation type",
				selectTextType: "Select text type",
				selectDateType: "Select date type"
			}
		},
		businessProcessManagement: {
			title: "Business process management",
			wizardTitle: "Create a business process",
			buttonText: "Create a process",
			workflowType: {
				wizardStepTitle: "Select workflow type",
				workflowTypeLabel: "Workflow type",
				workflowDescriptionLabel: "Workflow description",
				workflowNameLabel: "Workflow name",
				workflowTypeEnum: {
					1: "Case",
					2: "Act",
					3: "InternalAct",
					4: "Submission",
					5: "IncomingShipment",
					6: "Document"
				},
				confirmEnable: "Are you sure you want to enable the workflow?",
				confirmDisable: "Are you sure you want to enable the workflow?",
				disableWorkflowError: "An error ocurred while trying to disable workflow",
				disableWorkflowSuccess: "Workflow successfuly disabled",
				enableWorkflowError: "An error ocurred while trying to enable workflow",
				enableWorkflowSuccess: "Workflow successfuly enabled"
			},
			workflowEvents: {
				cardTitle: "Event",
				wizardStepTitle: "Select workflow events and conditions",
				selectEventLabel: "Select a type of event",
				createEventLabel: "Create an event",
				selectConditionLabel: "Select a condition",
				incomingShipmentCreatedEvent: "Incoming shipment created",
				caseCreatedEvent: "Case created",
				documentCreatedEvent: "Document created",
				documentApprovedEvent: "Document approved"
			},
			workflowSteps: {
				cardTitle: "Step",
				wizardStepTitle: "Select workflow steps",
				createCaseStepLabel: "Create case",
				createSubmissionStepLabel: "Create submission",
				requestDocumentApprovalStepLabel: "Request document approval",
				setDocumentValidityDatesStepLabel: "Set validity dates",
				setDocumentStatusToReleasedStepLabel: "Set document status to 'Released'"
			},
			workflowDefinitions: {
				modalTitle: "Workflow definition details",
				title: "Configured workflows",
				buttonText: "Show"
			},
			initiatedWorkflows: {
				modalTitle: "Initated workflow details",
				title: "Initiated workflows",
				buttonText: "Show",
				stepStatusEnum: {
					0: "Planned",
					1: "Current",
					2: "WaitingForResolution",
					3: "WaitingForPreviousStep",
					4: "Completed",
					5: "Failed",
					6: "PreviousStepFailed"
				}
			}
		},
		zupIt: {
			administrativeAreas: "Administrative areas",
			administrativeJobs: "Administrative jobs",
			administrativeMatters: "Administrative matters",
			confirmationTypes: "Confirmation types",
			legislations: "Legislations",
			officialRecords: "Official records",
			pleadingStatuses: "Pleading statuses",
			branchOfficeConfiguration: {
				title: "Branch office configuration",
				endOfWork: "End of working hours",
				saveZupItMethodologyConfirmationText: "Are you sure you want to save ZUP IT methodology?",
				saveZupItCodebooksConfirmationText: "Are you sure you want to save ZUP IT codebooks?",
				saveZupItMethodologyButtonText: "Save ZUP IT methodology",
				saveZupItCodebooksButtonText: "Save ZUP IT codebooks",
				startCertificationButtonText: "Start certification",
				stopCertificationButtonText: "Stop certification",
				cancelCertificationButtonText: "Cancel certification",
				runScenarioButtonText: "Run scenario Scenario1",
				startCertificationConfirmationText: "Are you sure you want to start ZUP IT certification?",
				stopCertificationConfirmationText: "Are you sure you want to stop ZUP IT certification?",
				cancelCertificationConfirmationText: "Are you sure you want to cancel ZUP IT certification?",
				runScenarioConfirmationText: "Are you sure you want to run scenario: Scenario1?"
			},
			publicCompanies: {
				title: "Public companies",
				setAsExecutingCompanySuccess: "Setting executing JPT set successfully",
				setAsExecutingCompanyError: "Error occurred while setting executing JPT",
				removeAsExecutingCompanySuccess: "Removing executing JPT set successfully",
				removeAsExecutingCompanyError: "Error occurred while remove executing JPT",
				confirmRemovingExecutingCompany: "Are you sure you wan't to set executing JPT?",
				confirmSettingExecutingCompany: "Are you sure you wan't to remove executing JPT?",
				set: "Set as executing JPT",
				unset: "Remove as executing JPT"
			},
			outboxMessages: "Outbox messages",
			users: "Users"
		},
		finaInvoice: {
			tableTitle: "List of e-invoices",
			tableTooltip: "Select e-invoice to automatically fill in the form",
			invoiceId: "Invoice ID",
			supplierId: "Supplier ID",
			invoiceDate: "Invoice date",
			invoicePayableAmount: "Amount [EUR]",
			invoiceStatus: "Status",
			showPdfTooltip: "Prikaži PDF",
			changeInvoiceStatus: "Change status",
			changeInvoiceStatusPrompt: "Are you sure you want to change invoice status?",
			changeInvoiceStatusSuccess: "Status successfully changed!",
			invoiceStatusEnumMap: {
				1: "Received",
				2: "Receiving confirmed",
				3: "Approved",
				4: "Rejected",
				5: "Payment fulfilled",
				6: "Payment partially fulfilled"
			}
		},
		applicationConfig: {
			title: "Application config",
			mailboxes: {
				title: "Mailboxes",
				emailSuccessfullySentTo: "Email successfully sent to ",
				serverAddress: "Server address",
				encryptionType: "Encryption type",
				automaticallyReadEmails: "Automatically read emails",
				lastReadDate: "Last read date",
				smtpSettings: "SMTP settings",
				imapSettings: "IMAP settings"
			},
			edeliveries: {
				title: "e-Delivery",
				configuration: {
					title: "Configuration"
				}
			},
			deadlineConfiguration: {
				title: "Deadline configuration",
				proceedingType: {
					title: "By proceeding type",
					minNumberOfDaysLabel: "Min. number of days",
					maxNumberOfDaysLabel: "Max. number of days",
					defaultNumberOfDaysLabel: "Default number of days"
				},
				submission: {
					title: "By submission"
				}
			},
			notificationsConfiguration: {
				title: "Notifications",
				notificationMarkedAsReadSuccess: "Notification marked as read",
				allNotificationsMarkedAsReadSuccess: "All notifications marked as read",
				employees: {
					title: "Employees"
				},
				priorities: {
					title: "Priorities"
				},
				types: {
					title: "Types",
					disableNotificationSuccess: "Notification successfuly turned off",
					disableNotificationError: "An error ocurred while trying to disable notification",
					enableNotificationSuccess: "Notification successfuly turned on",
					enableNotificationError: "An error ocurred while trying to enable notification",
					confirmEnable: "Are you sure you want to enable the notification?",
					confirmDisable: "Are you sure you want to disable the notification?"
				},
				notificationGroupEnum: {
					label: "Notification group",
					1: "Case",
					2: "Act",
					3: "Internal act",
					4: "Submission",
					5: "Incoming shipment",
					6: "Document"
				},
				notificationTypeEnum: {
					label: "Notification type",
					1: "Case created",
					2: "Case status changed",
					3: "Case assigned",
					4: "Case cancelled",
					100: "Act created",
					101: "Act status changed",
					102: "Act assigned",
					103: "Act cancelled",
					104: "Act deadline approaching",
					105: "Act approved",
					106: "Act approval granted",
					107: "Act approval rejected",
					108: "Act approval requested",
					109: "Act rejected",
					200: "Internal act created",
					201: "Internal act status changed",
					202: "Internal act assigned",
					203: "Internal act cancelled",
					204: "Internal act deadline approaching",
					205: "Internal act approved",
					206: "Internal act approval granted",
					207: "Internal act approval rejected",
					208: "Internal act approval requested",
					209: "Internal act rejected",
					300: "Submission created",
					301: "Submission status changed",
					302: "Submission assigned",
					303: "Submission cancelled",
					304: "Submission deadline approaching",
					305: "Submission approved",
					306: "Submission approval granted",
					307: "Submission approval rejected",
					308: "Submission approval requested",
					309: "Submission rejected",
					400: "Incoming shipment created",
					500: "Document assigned",
					501: "Document approved",
					502: "Document approval granted",
					503: "Document approval rejected",
					504: "Document approval requested",
					505: "Document status changed",
					506: "Document rejected",
					507: "Document expiry approaching"
				},
				notificationChannelEnum: {
					1: "Dashboard",
					2: "Email"
				},
				schedules: {
					add: "Add a schedule",
					remove: "Remove schedule"
				},
				referentPropertyPlaceholder: "Referentni datum",
				timeUnitPlaceholder: "Period",
				timeUnitEnum: {
					placeholder: "Time unit",
					1: "Seconds",
					2: "minutes",
					3: "Hours",
					4: "Days"
				},
				relativeToDateEnum: {
					placeholder: "Priority",
					1: "Before date"
				},
				priorityEnum: {
					placeholder: "Priority",
					1: "Low",
					2: "Medium",
					3: "High",
					4: "Critical"
				}
			},
			dashboardNotifications: {
				title: "Notifications",
				allNotificationsLabel: "All",
				emptyNotificationsLabel: "No new notifications!",
				markAllAsReadTooltipText: "Mark all as read"
			},
			finaInvoiceCertificates: {
				title: "FINA e-Invoice",
				certificateValid: "Certificate is valid",
				certificateInvalid: "Certificate is invalid"
			}
		},
		dms: {
			title: "DMS",
			documents: {
				title: "Documents",
				documentTitlePlaceholder: "Document title",
				confirmLock: "Are you sure you want to lock the document?",
				confirmUnlock: "Are you sure you want to unlock the document?",
				lockDocumentFailure: "Error ocurred while locking the document",
				lockDocumentSuccess: "Document locked successfuly",
				unlockDocumentFailure: "Error ocurred while unlocking the document",
				unlockDocumentSuccess: "Document unlocked successfuly",
				documentsAudit: "Document audit",
				auditExportFileName: "document-audit-export",
				approvals: {
					title: "Approvals",
					approveButtonText: "Approve",
					approvalApprovedMessage: "Document approved!",
					rejectButtonText: "Reject",
					approvalRejectedMessage: "Document rejected!",
					requestApprovalButtonText: "Request approval",
					approvalRequestedMessage: "Approval requested",
					approvalReason: "Reason",
					sentApprovalsTitle: "Sent approvals",
					emptySentApprovalsLabel: "No sent approvals",
					receivedApprovalsTitle: "Received approvals",
					emptyReceivedApprovalsLabel: "No received approvals",
					refreshApprovalsListButtonTooltipText: "Refresh approvals list",
					wrongApprovalStatusCondition: "Approval can be requested only for documents with status 'Created', 'Released' or 'Review granted'",
					wrongReviewStatusCondition: "Review can be requested only for documents with status 'Created' or 'Released'",
					saveChangesFirstConfirmation:
						"Request will be sent to users: {{initialUsers}}. If you made changes to users, please save them before sending the request. Do you wish to continue?"
				},
				documentLockedChangeStatusTooltipText: "To change the status of the document, it needs to be unlocked first.",
				changeStatusConfirmation: "Document status will be changed to '{{documentStatus}}, do you want to continue?",
				changeStatusButtonTextPrefix: "Change status -> ",
				changeStatusSuccessMessage: "Status of the document '{{name}}' successfully changed to '{{newDocumentStatus}}'!",
				statusEnums: {
					0: "Created",
					1: "Released",
					2: "Archived",
					3: "Approval requested",
					4: "Rejected",
					5: "Approved"
				},
				createDocumentFromTemplate: {
					toolbarButtonText: "Create document from template",
					rowButtonText: "Create document",
					selectDmsDocTypeTemplateStep: {
						title: "Template selection",
						selectDoctypePlaceholder: "Select document type",
						selectTemplatePlaceholder: "Select template"
					},
					createDocumentStep: {
						title: "Create document"
					},
					navigateToDocumentStep: {
						title: "Document created",
						documentCreatedMessage: "Document successfully created!",
						documentErrorMessage: "An error occurred while creating document!",
						linkToDocumentButtonText: "Go to document {{documentName}}"
					}
				}
			},
			documentFiles: {
				tabTitle: "File versions",
				restoreFileFailure: "Error ocurred during file restoration process",
				restoreFileSuccess: "File restored successfuly",
				confirmRestoreFile: "Are you sure you want to restore the document to this version?",
				previewFile: "Preview",
				editFile: "Edit",
				saveNewVersion: "Save new version",
				saveNewVersionSuccess: "New version saved successfuly!",
				replaceWithNewFileSuccess: "File replaced successfuly!",
				documentLockedEditButtonTooltip: "To edit the document, it needs to be unlocked first.",
				replaceWithFileToolbarButton: "Replace active document file",
				replaceWithExistingFileButtonText: "Replace with existing file",
				replaceWithNewFileButtonText: "Replace with new file"
			}
		},
		archive: {
			title: "Archive",
			archiveModal: {
				title: "Archive",
				tableTitle: "Overview of cases for archive",
				archiveButtonText: "Archive",
				archiveRecordPlaceholder: "Select archival record",
				archiveRecordHeader: "Archival record",
				caseTitleHeader: "Case title",
				caseClassificationMarkHeader: "Classification mark",
				legalBasePlaceholder: "Select legal base",
				legalBaseHeader: "Legal base",
				archivedDateHeader: "Archived date",
				holdIndefinitelyHeader: "Hold indefinitely",
				keepUntilHeader: "Keep until",
				noCasesSuitableForArchivalMessage: "No cases suitable for archival were selected",
				noCasesSuitableForArchivalTitle: "Archive error"
			},
			archivedCases: {
				title: "Archived cases",
				baseExportFileName: "archived-cases"
			},
			archivalEntries: {
				title: "Archival entries"
			},
			archiveLogEntries: {
				title: "Archive log entries",
				baseExportFileName: "archive-log-entries"
			},
			codebooks: {
				title: "Codebook",
				archivalFonds: {
					title: "Archival fonds"
				},
				archivalSubFonds: {
					title: "Archival sub fonds"
				},
				archivalSeries: {
					title: "Archival series"
				},
				archivalLegalBases: {
					title: "Archival legal bases"
				},
				archivalRecords: {
					title: "Archival records"
				},
				archivalTechnicalUnits: {
					title: "Archival technical units"
				}
			}
		},
		reports: {
			title: "Reports",
			downloadLink: "Download report",
			filter: "Filtering",
			registry: {
				title: "Registry",
				registryBook: {
					title: "Registry book"
				},
				firstDegreeRegistry: {
					title: "First degree registry"
				},
				secondDegreeRegistry: {
					title: "Second degree registry"
				},
				documentRegistry: {
					title: "Document registry"
				},
				locationDeliveryBookRegistry: {
					title: "Location delivery book registry"
				},
				nonAdministrativeRegistry: {
					title: "Non-administrative registry"
				},
				casesForExtraction: {
					title: "List of cases for extraction"
				},
				caseHandbook: {
					title: "Case handbook"
				},
				deliveryMailBookRegistry: {
					title: "Delivery mail book registry"
				},
				receivedMailBookRegistry: {
					title: "Delivery mail book registry"
				},
				archivalRecordBookRegistry: {
					title: "Archival record book registry"
				},
				casesIssuedForInspection: {
					title: "List of cases issued for inspection"
				}
			},
			dispatch: {
				title: "Dispatch",
				postalDeliveryBook: {
					title: "Postal Delivery Book"
				},
				localDeliveryBook: {
					title: "Local Delivery Book"
				},
				receivedMailBook: {
					title: "Received Mail Book"
				}
			},
			archive: {
				title: "Archive",
				archiveBook: {
					title: "Archive Book"
				},
				disposalReadyList: {
					title: "List of Records Ready for Disposal"
				},
				recordsOnLoanList: {
					title: "List of Records Issued on Loan"
				}
			},
			statistics: {
				title: "Statistics",
				casesByStatusAndOrgUnit: {
					title: "Cases by status and organizational unit"
				},
				casesByStatusAndDossier: {
					title: "Cases by status and dossier"
				},
				casesByStatusAndAssignee: {
					title: "Cases by status and assignee",
					workplaceEmployeeFilterPlaceholder: "No employees selected - all employees"
				},
				averageResolutionTimeByCaseType: {
					title: "Average resolution time by case type"
				},
				pleadingsByTypeAndStatus: {
					title: "Pleadings by type and status"
				},
				transactionsByEmployee: {
					title: "Transactions by employee"
				}
			},
			kpi: {
				title: "KPI",
				includeOrgUnit: "Everybody from organizational unit",
				numberOfDays: "Number of days",
				configuration: {
					title: "Configuration"
				},
				casesWithoutAssignee: {
					title: "Cases without assignee"
				},
				unacceptedResolutions: {
					title: "Unaccepted resolutions older than [n] days"
				},
				pleadingsForSignature: {
					title: "Pleadings for signature/initials"
				},
				signedPleadingsForDispatch: {
					title: "Signed pleadings awaiting dispatch"
				},
				casesWithExpiredOrSoonDueDeadlines: {
					title: "Cases with approaching deadline"
				},
				averageDeliveryDuration: {
					title: "Average delivery time"
				},
				ratioOfCreatedAndResolvedCases: {
					title: "Created vs resolved cases ratio"
				},
				averageResolutionTimePerDossierTypeAndProcess: {
					title: "Average case resolution time"
				},
				dynamicsOfSigningAndApproving: {
					title: "Dynamics of signing and approving"
				},
				mostCommonProceedingTypeByCaseStatuses: {
					title: "Most common processes by status"
				},
				unresolvedCasesByWorkerWithDeadlines: {
					title: "Unresolved cases by employee"
				}
			}
		}
	},
	approvals: {
		saveChangesFirstTooltip: "You have unsaved changes. Please save the changes before requesting.",
		noReviewersCondition: "Reviewers need to be defined and changes need to be saved before requesting review",
		noApproversCondition: "Approvers need to be defined and changes need to be saved before requesting approval",
		notResponsibleEmployeeCondition: "Only the responsible employee can request approval or review.",
		saveChangesFirstConfirmation:
			"Request will be sent to users: {{initialUsers}}. If you made changes to users, please save them before sending the request. Do you wish to continue?",
		requestButtonText: {
			"0": "Request approval",
			"1": "Request review",
			"2": "Request signature"
		},
		requestSuccessMessage: {
			"0": "Approval requested",
			"1": "Review requested",
			"2": "Signature requested"
		}
	},
	import: {
		general: {
			validationErrorsDivider: "Validation errors",
			infoDivider: "Additional information",
			displayImportResultStep: "Import status",
			importStatus: {
				success: "Import completed successfuly",
				started: "Import started",
				validationFailed: "Import file validation failed",
				noRowsFoundInImport: "Empty import file",
				failed: "Import failed"
			},
			importResultTable: {
				title: "Import result overview",
				importStatusColumn: "Import status",
				importedRowsCountColumn: "Imported rows",
				failureReasonColumn: "Failure reason"
			},
			importValidationErrorsTable: {
				title: "Validation error overview",
				rowIndexColumn: "Row index",
				errorsColumn: "Validation errors"
			},
			infoTable: {
				title: "Additional info",
				rowIndexColumn: "Row index",
				infoColumn: "Info"
			},
			errors: {
				unknownError: {
					title: "Unknown error",
					detail: "An unknown error occurred"
				},
				somethingWentWrong: "Something went wrong",
				emptyImportFile: "Please upload valid import file",
				reviewErrorsAndTryAgain: "Please review and fix validation errors and try again"
			}
		},
		classificationPlans: {
			wizardTitle: "Import classification plan wizard",
			importMarksTitle: "Classification marks excel import",
			existingPlan: "Existing classification plan",
			existingPlanPlaceholder: "Enter classification plan title",
			newPlan: "New classification plan",
			classificationPlanData: "Classification plan data",
			importMarks: "Import classification marks",
			newPlanCreated: "New classification plan created"
		},
		workplaceSystematizations: {
			wizardTitle: "Create systematization",
			importSystematizationTitle: "Import excel file",
			displayOrgUnitImportResult: "Org units",
			displayEmployeeImportResult: "Employees",
			displayWorkplaceImportResult: "Workplaces",
			existingSystematizationPlaceholder: "Systematization title",
			newSystematization: "New systematization",
			existingSystematization: "Existing systematization",
			newSystematizationCreated: "New workplace systematization created",
			importSystematizationResultOverview: "Import result overview",
			importFromADSuccess: "Successfully imported systematization from Active Directory",
			importFromADError: "Failed to import systematization from Active Directory",
			resultOverviewTable: {
				title: "Import result overview",
				stepColumn: "Import step",
				stepStatusColumn: "Step status",
				stepStatusMessageColumn: "Message",
				importOrgUnitsStep: "Organizational units import",
				importWorkplacesStep: "Workplaces import",
				importEmployeesStep: "Employees import"
			}
		}
	},
	dataTable: {
		dateFrom: "{{date}} from",
		dateTo: "{{date}} to",
		createPleadings: "Create pleadings",
		itemsSelected: "Items selected: ",
		clearFilters: "Clear filters"
	},
	wizard: {
		pleadingsFromShipment: {
			title: "Create pleadings from shipment wizard",
			addShipmentWithPleadings: "Add shipment with pleadings",
			shipment: {
				title: "Create shipment",
				optionExisting: "Select existing shipment",
				optionNew: "Create new shipment",
				existingShipmentPlaceholder: "Enter shipment name",
				newShipmentCreated: "Shipment successfully created!"
			},
			shipmentFiles: {
				title: "Create shipment files",
				formItemLabel: "Files",
				existingFilesTitle: "Existing files",
				newShipmentFilesCreated: "Files successfully created!"
			},
			case: {
				title: "Select or create case",
				optionExisting: "Select existing case",
				optionNew: "Create new case",
				existingCasePlaceholder: "Enter case title",
				newCaseCreated: "Case successfully created!"
			},
			submission: {
				title: "Create submissions",
				newSubmissionCreated: "Submission successfully created!"
			},
			submissionFiles: {
				title: "Select submission attachments",
				selectFiles: "Select attachments from shipment"
			}
		},
		pleadingsFromInvoice: {
			title: "Create pleadings from invoice wizard",
			addInvoiceWithPleadings: "Add invoice with pleadings",
			invoice: {
				title: "Create invoice",
				optionExisting: "Select existing invoice",
				optionNew: "Create new shipment",
				existingInvoicePlaceholder: "Enter invoice name",
				newInvoiceCreated: "Invoice successfully created!"
			},
			case: {
				title: "Select or create case",
				optionExisting: "Select existing case",
				optionNew: "Create new case",
				existingCasePlaceholder: "Enter case title",
				newCaseCreated: "Case successfully created!"
			},
			submission: {
				title: "Create submission",
				newSubmissionCreated: "Submission successfully created!"
			},
			submissionFiles: {
				title: "Create submission attachments",
				selectFiles: "Select submission attachments"
			}
		},
		categoryRequestFromShipment: {
			title: "Create request from shipment wizard",
			shipment: {
				title: "Shipment",
				optionExisting: "Select existing shipment",
				optionNew: "Create new shipment",
				existingShipmentPlaceholder: "Enter shipment name",
				newShipmentCreated: "Shipment successfully created!"
			},
			shipmentFiles: {
				title: "Shipment files",
				formItemLabel: "Files",
				existingFilesTitle: "Existing files",
				newShipmentFilesCreated: "Files successfully created!"
			},
			case: {
				title: "Case",
				optionExisting: "Select existing case",
				optionNew: "Create new case",
				existingCasePlaceholder: "Enter case title",
				newCaseCreated: "Case successfully created!"
			},
			requestForm: {
				title: "Form",
				existingRequestFormPlaceholder: "Select existing form"
			},
			submission: {
				title: "Submission",
				optionExisting: "Select existing submission",
				optionNew: "Create new submission",
				existingSubsmissionPlaceholder: "Enter submission title",
				newSubmissionCreated: "Submission successfully created!"
			},
			submissionFiles: {
				title: "Submission attachments",
				selectFiles: "Select attachments from shipment"
			},
			athlete: {
				title: "Athlete data",
				newAthleteCreated: "Athlete successfully saved!"
			},
			categoryRequest: {
				title: "Request",
				newRequestCreated: "Request successfully created!"
			}
		},
		actFromRequest: {
			title: "Create resolution wizard",
			categoryRequest: {
				title: "Create or select request",
				optionExisting: "Select existing request",
				optionNew: "Create new request",
				existingRequestPlaceholder: "Enter request name",
				newRequestCreated: "Request successfully created!",
				requestUpdated: "Request successfully updated!"
			},
			submission: {
				title: "Select submission",
				existingSubmissionPlaceholder: "Enter submission name"
			},
			category: {
				title: "Create or select category",
				optionExisting: "Select existing category",
				optionNew: "Create new category",
				existingCategoryPlaceholder: "Enter category name",
				newCategoryCreated: "Category successfully created!",
				categoryUpdated: "Category successfully updated!"
			},
			act: {
				title: "Create act",
				newActCreated: "Act successfully created!"
			}
		},
		proceedingTypeTransformation: {
			rowButtonText: "Transform into administrative proceeding type",
			pleadingTransformedSuccessfully: "Pismeno uspješno transformirano!",
			createSelectCase: {
				title: "Create or select an administrative proceeding type case",
				newCaseCreatedMessage: "Administrative case successfully created!",
				optionExisting: "Select existing administrative case",
				optionNew: "Create new administrative case",
				existingCasePlaceholder: "Enter administrative case title"
			},
			createPleading: {
				title: "Create new administrative pleading",
				newPleadingCreated: "Administrative pleading successfully created!"
			},
			selectItems: {
				title: "Transfer pleading attachments",
				pleadingAttachmentsSuccessfullyCopied: "Uspješno kopirani prilozi i bilješke!",
				selectAllAttachments: "Select all attachments",
				selectAllNotes: "Select all notes"
			},
			cancelPleadingAndCase: {
				title: "Cancel pleading and case",
				cancelingSuccessful: "Canceling sucessful!!",
				cancelCase: "Cancel case '{{value}}'",
				cancelCaseSuccessful: "Case successfully canceled!",
				cancelPleading: "Cancel pleading '{{value}}'",
				cancelPleadingSuccessful: "Pleading sucessfully canceled!"
			}
		},
		nextStep: "Next",
		previousStep: "Previous"
	},
	imageGallery: {
		room: "Room",
		selectRoom: "Select a room",
		searchRooms: "Search rooms",
		noAssignedRoomSearch: "Search without an assigned room"
	},
	validations: {
		invalidPassportExpiryDate: "Invalid expiry year!",
		invalidCardNumber: "Input must contain exactly 9 digits!",
		valueNaN: "Value must be a number!",
		fieldRequired: "Field is required!",
		enterPossibleValues: "Enter possible values",
		enterDefaultValue: "Enter default value",
		maxCharLengthOf255: "Maximum length is 255 characters!",
		valueGTE: "Value must be greater than or equal to {{value}}!",
		valueLTE: "Value must be less than or equal to {{value}}!",
		valueNotInRange: "Value must be in range between {{min}} and {{max}}",
		minGTMax: "Minimal must be less than maximal value!",
		minLengthWithValue: "Minimal character length is {{value}}!",
		maxLengthWithValue: "Maximal character length is {{value}}!",
		valueAlreadyExists: "Value already exists!",
		singleValue: "Only one entry can be set!",
		emptySubjectOrBody: "The title or body of the message must be filled out!",
		incorrectEmailFormat: "Incorrect email format!",
		incorrectPhoneNumberFormat: "Incorrect phone number format!",
		incorrectOIBFormat: "Incorrect OIB format!",
		usernameAndPasswordOverrideBothRequired: "Both username and password overrides need to be set if one of them is set!",
		atLeastOneIdFieldRequired: "At least one form of ID must be provided!",
		exactLengthWithValue: `Field must contain exactly {{value}} characters!`
	},
	userAccess: {
		tabTitle: "Access rights",
		grantAccess: "Grant access",
		revokeAccess: "Revoke access",
		manageAccesses: "Manage accesses",
		accessType: "Access type",
		readAccess: "Read",
		writeAccess: "Write",
		deleteAccess: "Delete",
		importAccess: "Import",
		forPeriod: "For period",
		reason: "Reason"
	},
	errors: {
		refreshPage: "Please refresh the page or try again later.",
		pageNotExists: "Visited page does not exist",
		unauthorizedTitle: "Unauthorized access!",
		unauthorizedSubTitle: "You do not have sufficient permissions to view the page, please contact the administrator",
		backToHomepage: "Back to homepage",
		toHomepage: "To homepage",
		unknownError: "Unknown error",
		somethingWentWrong: "Something went wrong",
		networkError: {
			title: "Network error",
			detail: "Make sure your internet connection is working"
		},
		errorCode: "Error code",
		http: {
			400: {
				title: "Bad Request",
				detail: "Invalid or incomplete request. Please check your input."
			},
			401: {
				title: "Unauthorized",
				detail: "Authentication failed. Ensure you have the correct credentials."
			},
			403: {
				title: "Forbidden",
				detail: "Access denied. You don't have permission to view this content."
			},
			404: {
				title: "Not Found",
				detail: "The requested page or resource doesn't exist. Verify the URL."
			},
			408: {
				title: "Request Timeout",
				detail: "Request timed out. Please check your network connection."
			},
			409: {
				title: "Concurrency error",
				detail: "Someone else updated the entity. Reload the page and try again."
			},
			429: {
				title: "Too Many Requests",
				detail: "Too many requests. Slow down and try again later."
			},
			500: {
				title: "Internal Server Error",
				detail: "Internal server error. The server encountered an issue."
			},
			502: {
				title: "Bad Gateway",
				detail: "Bad gateway. There's a problem with the upstream server."
			},
			503: {
				title: "Service Unavailable",
				detail: "Service unavailable. The server is currently down."
			},
			504: {
				title: "Gateway Timeout",
				detail: "Gateway timeout. The server is taking too long to respond."
			},
			formValidations: {
				requiredFields: {
					title: "Incomplete form",
					description: "Required fields missing"
				}
			}
		},
		errorCodeEnumMessages: {
			"1": "Only one default workplace per user.",
			"2": "A logged-in employee is required to create a pleading.",
			"3": "A logged-in employee is required to update a pleading.",
			"4": "A logged-in employee is required to create a case.",
			"5": "A logged-in employee is required to update a case.",
			"6": "Workflow step input parameter validation failed.",
			"7": "Previous workflow step output parameter validation failed.",
			"8": "User must be assigned to the pleading to request approval.",
			"9": "Only the assigned user can request approval.",
			"10": "Invalid pleading status transition.",
			"11": "You can only approve or reject your own approval requests.",

			// Email attachment download link error codes
			"100": "Download link was not found.",
			"101": "Download link has already been used.",
			"102": "Download link has expired.",
			"103": "There are no attachments to download.",

			// Croatian Olympic Committee
			"300": "The category request form is in use.",

			// Identity error codes
			"1000": "The username already exists.",

			// Import error codes
			"2000": "A tenant is mandatory in the import procedure.",

			// DMS error codes
			"3000": "A logged-in employee is required to create a document.",
			"3001": "A logged-in employee is required to update a document.",
			"3002": "Updating a locked document is not allowed.",
			"3003": "A logged-in employee is required to lock a document.",
			"3004": "A logged-in employee is required to unlock a document.",
			"3005": "User must be assigned to the document to request approval.",
			"3006": "Invalid document status transition.",

			// ePK error codes
			"4000": "An error occurred while generating the ePK file."
		}
	},
	common: {
		yes: "Yes",
		no: "No",
		minimal: "Minimal",
		maximal: "Maximal",
		active: "Active",
		preferred: "Preferred",
		save: "Save",
		saveAndContinue: "Save and continue",
		saveAndFinish: "Save and finish",
		back: "Back",
		cancel: "Cancel",
		close: "Close",
		change: "Change",
		finish: "Finish",
		submit: "Submit",
		show: "Show",
		showFile: "Show file",
		showAsPdf: "Show as PDF",
		edit: "Edit",
		delete: "Delete",
		clear: "Clear",
		adding: "Adding",
		editing: "Editing",
		search: "Search",
		searchWithValue: "Search {{value}}",
		searchAll: "Search all",
		add: "Add",
		confirm: "Confirm",
		remove: "Remove",
		load: "Load",
		export: "Export",
		exportGrid: "Export table",
		noDataForExportMessage: "No data for export",
		noDataForExportDetail: "Selected filters resulted in no data for export. Please change the filters and try again.",
		loading: "Loading..",
		download: "Download",
		downloadAsArchive: "Download as archive",
		refresh: "Refresh",
		disabled: "Disabled",
		created: "Created",
		modified: "Modified",
		replace: "Replace",
		start: "Start",
		end: "End",
		name: "Name",
		title: "Title",
		type: "Type",
		ofPleading: "Of Pleading",
		date: "Date",
		month: "Month",
		forPeriod: "For period",
		createdDate: "Creation date",
		modifiedDate: "Modification date",
		time: "Time",
		dateAndTime: "Date and time",
		description: "Description",
		details: "Details",
		default: "Default",
		errorOccurred: "An error occurred!",
		errorChangesNotSaved: "",
		changesSavedSuccess: "Changes successfully saved!",
		deleteSuccess: "Deleted successfully!",
		deleteError: "An error occurred, delete failed!",
		deleteItemQuestion: "Are you sure you want to delete the item?",
		deleteItemsQuestion: "Are you sure you want to delete items?",
		generalData: "General data",
		instructions: "Instructions",
		discardChanges: "Are you sure you want to discard changes?",
		valueFrom: "{{value}} from",
		valueTo: "{{value}} to",
		attachments: "Attachments",
		activate: "Activate",
		deactivate: "Deactivate",
		validFrom: "Valid from",
		validTill: "Valid till",
		enable: "Enable",
		disable: "Disable",
		copy: "Copy",
		paste: "Paste",
		setAsDefault: "Set as default",
		setAsDefaultSuccess: "Record is successfuly set as default",
		setAsDefaultError: "An error ocurred, record is not set as default",
		document: "Document",
		exportSuccess: "Export successful!",
		exportError: "An error occurred during export!",
		exportBaseFileName: "TableExport",
		exportConfirmationText: "Are you sure you want to export data with applied filters?",
		createFileError: "an error ocurred while creating file",
		reports: "Reports",
		additionalData: "Additional data",
		importFromExcel: "Import from Excel",
		importFromAD: "Import from Active Directory",
		excelFile: "Excel file",
		system: "System",
		uploadFile: "Upload file",
		fileName: "File name",
		version: "Version",
		isActive: "Is active",
		lock: "Lock",
		unlock: "Unlock",
		set: "Set",
		restore: "Restore",
		filterBy: "Filter by",
		byYear: "By year",
		datePeriod: "Date period",
		dateFrom: "Date from",
		dateTo: "Date to",
		format: "Format",
		class: "Class",
		selectClass: "Select class",
		organizationalUnit: "Organizational unit",
		selectOrganizationalUnit: "Select organizational unit",
		employee: "Employee",
		selectEmployee: "Select employee",
		caseStatus: "Case status",
		selectCaseStatus: "Select case status",
		dossier: "Dossier",
		selectDossier: "Select dossier",
		pleadingStatus: "Pleading status",
		selectPleadingStatus: "Select pleading status",
		proceedingType: "Proceeding type",
		selectProceedingType: "Select proceeding type",
		pleadingType: "Pleading type",
		selectPleadingType: "Select pleading type"
	},
	authButton: {
		impersonation: {
			employeePlaceholder: "Employee",
			branchOfficePlaceholder: "Branch office"
		}
	},
	fileViewer: {
		pdfViewerError: "PDF viewer error. File could not be loaded or does not exist!"
	},
	signatures: {
		signaturePanel: {
			title: "Signature Panel",
			signButton: "Sign",
			tabs: {
				usbToken: "Sign with USB Token",
				draw: "Draw Signature",
				upload: "Upload Signed Document"
			},
			messages: {
				documentSignedSuccess: "Document successfully signed with USB token",
				signatureError: "Error saving signature",
				signatureSaved: "Signature successfully saved",
				documentSavedAsAttachment: "Signed document successfully saved as attachment",
				documentSaved: "Signed document successfully saved",
				noFileSelected: "No file selected",
				documentSaveError: "Error saving document",
				selectDocumentForSigning: "Please select a document for signing",
				selectDocumentForUsbSigning: "Please select a document for USB token signing"
			},
			upload: {
				dragText: "Click or drag file to this area",
				hint: "PDF or image files are supported",
				cancel: "Cancel",
				save: "Save",
				fileTypeError: "You can only upload PDF or image files!"
			}
		},
		validation: {
			title: "Digital Signature Validation",
			validateSignatures: "Validate Signatures",
			validating: "Validating signatures...",
			validationError: "Error validating signatures",
			noAttachmentsSelected: "No attachments selected",
			valid: "Valid",
			invalid: "Invalid",
			unknownSigner: "Unknown Signer",
			documentName: "Document: {{name}}",
			overallStatus: "Overall Status",
			documentHash: "Document Hash",
			validationTimestamp: "Validation Timestamp",
			signaturesCount: "Number of Signatures",
			validationErrors: "Validation Errors",
			signaturesDetails: "Signature Details",
			signerName: "Signer Name",
			signerEmail: "Signer Email",
			signedDate: "Signed Date",
			signatureReason: "Signature Reason",
			signatureLocation: "Signature Location",
			contactInfo: "Contact Information",
			signatureStatus: "Signature Status",
			signatureValid: "Signature Valid",
			certificateValid: "Certificate Valid",
			validationMessages: "Validation Messages",
			certificateDetails: "Certificate Details",
			certificate: {
				subject: "Subject",
				issuer: "Issuer",
				serialNumber: "Serial Number",
				certificateType: "Certificate Type",
				trustLevel: "Trust Level",
				qualificationLevel: "Qualification Level",
				validFrom: "Valid From",
				validTo: "Valid To",
				thumbprint: "Thumbprint",
				keyAlgorithm: "Key Algorithm",
				signatureAlgorithm: "Signature Algorithm",
				version: "Version",
				status: "Certificate Status",
				expired: "Expired",
				notYetValid: "Not Yet Valid",
				valid: "Valid",
				keyUsages: "Key Usages",
				enhancedKeyUsages: "Enhanced Key Usages",
				types: {
					Unknown: "Unknown",
					SelfSigned: "Self-Signed",
					DomainValidated: "Domain Validated",
					OrganizationValidated: "Organization Validated",
					ExtendedValidation: "Extended Validation",
					CodeSigning: "Code Signing",
					TimeStamping: "Time Stamping",
					EmailSigning: "Email Signing",
					DocumentSigning: "Document Signing",
					Qualified: "Qualified",
					QualifiedWebsiteAuthentication: "Qualified Website Authentication",
					QualifiedSeal: "Qualified Seal"
				},
				trustLevels: {
					Unknown: "Unknown",
					Untrusted: "Untrusted",
					SelfSigned: "Self-Signed",
					Trusted: "Trusted",
					HighlyTrusted: "Highly Trusted",
					GovernmentTrusted: "Government Trusted"
				},
				qualificationLevels: {
					Unknown: "Unknown",
					Basic: "Basic",
					Advanced: "Advanced",
					Qualified: "Qualified",
					AdvancedWithQSCD: "Advanced with QSCD",
					QualifiedWithQSCD: "Qualified with QSCD"
				}
			}
		},
		usbTokenSigning: {
			title: "USB Token Signing",
			certificateDetection: {
				title: "Certificate Detection",
				detectButton: "Detect USB Token",
				refreshButton: "Refresh",
				detectingMessage: "Detecting USB token and loading certificates...",
				availableCertificates: "Available Certificates:",
				noDigitalIds: "No digital IDs found. Please insert a USB token or install a digital ID.",
				certificatesFound: "Found {{count}} hardware-backed certificate(s)",
				certificateSelected: "Certificate selected: {{name}}. Driver will prompt for PIN when signing.",
				selectCertificateFirst: "Please select a certificate first"
			},
			signing: {
				generatingHash: "Generating document hash...",
				signingMessage: "Signing hash with USB token... Driver may prompt for PIN.",
				invalidHashFormat: "Invalid hash format received from server",
				hashLengthMismatch: "Hash length mismatch: Expected {expected} characters for {algorithm}, got {actual}. Original format: {format}",
				signDocumentButton: "Sign Document",
				signingDocumentInProgress: "Signing..."
			},
			documentHash: {
				hexadecimal: "Hexadecimal",
				base64Conversion: "Base64 (will be converted to hex)"
			},
			certificates: {
				usbTokenLabel: "(USB Token Certificate)",
				issuedBy: "Issued by:",
				expires: "Expires:",
				subject: "Subject:",
				issuer: "Issuer:",
				validFrom: "Valid From:",
				validTo: "Valid To:",
				serialNumber: "Serial Number:",
				thumbprint: "Thumbprint:",
				hasPrivateKey: "Has Private Key:",
				hardwareBacked: "Hardware Backed:",
				yes: "Yes",
				no: "No"
			},
			cades: {
				successMessage: "CAdES Signature completed successfully!",
				signatureFormat: "Signature Format:",
				algorithm: "Algorithm:",
				signingTime: "Signing Time:",
				certificateChain: "Certificate Chain:",
				certificates: "certificate(s)",
				message: "Message:",
				completedMessage: "CAdES signature completed: {message}"
			},
			errors: {
				error: "Error:",
				unknownError: "Unknown error",
				signingDocument: "Error signing document:"
			}
		}
	}
};

export default en;
